export const US_COUNTRY_CODE = 'US';
export const CANADA_COUNTRY_CODE = 'CA';
export const UNITED_KINGDOM_COUNTRY_CODE = 'GB';
export const CALIFORNIA_REGION_CODE = 'CA';
export const MINNESOTA_REGION_CODE = 'MN';
export const NEW_YORK_REGION_CODE = 'NY';

export const REGULATED_COUNTRY_CODES = [US_COUNTRY_CODE, CANADA_COUNTRY_CODE, UNITED_KINGDOM_COUNTRY_CODE] as const;
export const REGULATED_US_REGION_CODES = [CALIFORNIA_REGION_CODE, MINNESOTA_REGION_CODE, NEW_YORK_REGION_CODE];

export interface RegulatedCountry {
    regions?: string[];
}

type RegulationConfig = {
    [key in (typeof REGULATED_COUNTRY_CODES)[number]]: RegulatedCountry;
};

export const REGULATION_CONFIG: RegulationConfig = {
    [US_COUNTRY_CODE]: {
        regions: REGULATED_US_REGION_CODES,
    },
    [CANADA_COUNTRY_CODE]: {},
    [UNITED_KINGDOM_COUNTRY_CODE]: {},
} as const;
